import * as React from 'react';
import { Responsive } from '@cian/ui-kit';
import { SortingDesktop } from './components/SortingDesktop';
import { SortingMobile } from './components/SortingMobile';

import * as style from './Sorting.css';
import { ISortingProps } from './types';

export const Sorting: React.FC<ISortingProps> = props => {
  return (
    <div className={style['container']}>
      <Responsive phone>
        <SortingMobile {...props} />
      </Responsive>
      <Responsive desktop tablet>
        <SortingDesktop {...props} />
      </Responsive>
    </div>
  );
};
